import { get } from '.';

export function GetVehicleModelYearDefinitions(options = {}) {
	return get<any>("/app/api/vehicle_model_year_definitions", options);
}

export function GetDistinctVehicleModelYears(options = {}) {
	return get<any>("/app/api/vehicle_model_year_definitions/distinct", options);
}
